module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/sheshines-11-dec-2025.json
// module id = 1488
// module chunks = 205455499864093